// src/pages/IPanel.jsx
import { useContext, useEffect, useState } from "react";
import "react-circular-progressbar/dist/styles.css";

import InstructorWeekCalendar from "../components/IPanel/InstructorWeekCalendar";
import { openPopup } from "../components/Common/popupUIStore";
import { UserContext } from "../UserContext";
import { isSubstituteInstructorType } from "../constants/instructors";
import { getInstructors } from "../api/instructorsService";
import { listenCalendarRefresh } from "../components/Utils/calendarBus";
import { getInstructorLessonEvents } from "../utils/instructorCalendarEvents";
import { loadPersonalCalendarEvents } from "../utils/personalCalendarEvents";

import NextLesson from "../components/SPanel/NextLesson";
import VideosPlayTile from "../components/Common/VideosPlayTile";
import TodayInfo from "../components/IPanel/TodayInfo";
import InstrPanelHeader from "../components/IPanel/InstrPanelHeader";
import Footer from "../components/Footer";

const SUBSTITUTE_HOME_REFRESH_MS = 35000;

function IPanel() {
   const { user } = useContext(UserContext);
   const [myInstructor, setMyInstructor] = useState(null);
   const [substitutionRefreshTick, setSubstitutionRefreshTick] = useState(0);
   const [nextLesson, setNextLesson] = useState(null);
   const [nextLessonIndex, setNextLessonIndex] = useState(null);
   const [events, setEvents] = useState([]);

   useEffect(() => {
      return listenCalendarRefresh((payload) => {
         if (
            String(payload?.type || "")
               .trim()
               .toLowerCase() !== "substitutions-changed"
         ) {
            return;
         }
         setSubstitutionRefreshTick((tick) => tick + 1);
      });
   }, []);

   useEffect(() => {
      if (!isSubstituteInstructorType(myInstructor?.instructorType)) return undefined;
      if (typeof window === "undefined") return undefined;

      const intervalId = window.setInterval(() => {
         if (document.hidden) return;
         setSubstitutionRefreshTick((tick) => tick + 1);
      }, SUBSTITUTE_HOME_REFRESH_MS);

      return () => {
         window.clearInterval(intervalId);
      };
   }, [myInstructor?.instructorType]);

   useEffect(() => {
      let cancelled = false;
      (async () => {
         if (!user) return;
         if (user.role !== "INSTRUCTOR") {
            setMyInstructor(null);
            return;
         }
         try {
            const all = await getInstructors();
            const mine = all.find((i) => String(i.userId) === String(user.id));
            if (!cancelled) setMyInstructor(mine || null);
         } catch {
            if (!cancelled) setMyInstructor(null);
         }
      })();
      return () => {
         cancelled = true;
      };
   }, [user]);

   useEffect(() => {
      let cancelled = false;

      (async () => {
         if (user?.role !== "INSTRUCTOR" || !myInstructor?.id) return;

         try {
            // lecțiile mele (și zilele în care înlocuiesc) — din /api/calendar (view=personal), ca în calendarul nou
            const allEvents = await loadPersonalCalendarEvents();
            if (cancelled) return;

            setEvents(allEvents);

            const lessons = getInstructorLessonEvents(allEvents);
            const now = new Date();
            const sorted = [...lessons].sort((a, b) => a.start - b.start);
            const upcomingIdx = sorted.findIndex((event) => event.start >= now);
            const upcoming = upcomingIdx >= 0 ? sorted[upcomingIdx] : null;

            setNextLesson(upcoming || null);
            setNextLessonIndex(upcoming ? upcomingIdx + 1 : null);
         } catch {}
      })();

      return () => {
         cancelled = true;
      };
   }, [user, myInstructor, substitutionRefreshTick]);

   const handleEventClick = (event) => {
      openPopup("eventInfo", { event });
   };

   return (
      <main className="main">
         <section className="intro student">
            <InstrPanelHeader user={user} />
            <div className="intro__right">
               <TodayInfo />

               <div className="intro__clock-wrapper">
                  <VideosPlayTile to="/instructor/videoclipuri" />
                  <NextLesson
                     nextLesson={nextLesson}
                     nextLessonIndex={nextLessonIndex}
                     instr="instr"
                  />
               </div>
            </div>
         </section>

         <section className="calendar student">
            <InstructorWeekCalendar
               events={events}
               onSelectEvent={handleEventClick}
            />
         </section>

         <Footer />
      </main>
   );
}

export default IPanel;
